// The controllable `id`/`show`/`alertModal` Modal API lives in the "next" component set,
// not the top-level "@vibe/core" barrel (which still re-exports the legacy antd-style Modal
// under the same name). See @vibe/core/dist/components/next/index.d.ts.
import { Modal, ModalContent } from "@vibe/core/next";
import LegalConsentForm from "./LegalConsentForm";
import { CONSENT_SOURCE_APP_GATE } from "../../data/constants/legalPolicies";
import "./LegalConsentModal.css";

interface LegalConsentModalProps {
  open: boolean;
  onComplete: () => void;
  source?: string;
}

// Blocking modal: `alertModal` disables overlay-click + ESC, the close (X) button is hidden via
// LegalConsentModal.css, and `onClose` is inert as a belt-and-suspenders guard. Only a successful
// consent record (onComplete) closes it.
const LegalConsentModal = ({
  open,
  onComplete,
  source = CONSENT_SOURCE_APP_GATE,
}: LegalConsentModalProps) => (
  <Modal
    id="legal-consent-modal"
    show={open}
    onClose={() => {}}
    alertModal
    closeButtonAriaLabel="Consent required"
  >
    <ModalContent>
      <div className="p-4">
        <LegalConsentForm onComplete={onComplete} source={source} />
      </div>
    </ModalContent>
  </Modal>
);

export default LegalConsentModal;
